import { render, staticRenderFns } from "./SideBarReports.vue?vue&type=template&id=247ec9d0"
import script from "./SideBarReports.vue?vue&type=script&lang=js"
export * from "./SideBarReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports